export const HOME_BLOG_POST = 1;
export const HOME_DOCUMENT = 2;
export const SENIOR_DOCUMENT = 3;
export const FAMILY_USER_MESSAGE = 4;
export const SENIOR_MESSAGE = 5;
export const ACTIVITY = 6;
